module.exports = __webpack_public_path__ + "img/KPlus.a84b9d89.png";